import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue';


export const obrazecService = {
    load,loadAll,loadLastYear,save,remove,isci,vrniPoId,vrniIpKontrolniList,vrniIpKontrolniListNR,vrniDatoteko
    
};
function isci(isci) {
    const requestOptions = {
        method: 'GET',
        //headers:authHeader(),
        
    };
return fetch(`${Vue.prototype.$config.apiUrl}/javno/certifikat/?isci=${isci}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {
            // login successful if there's a jwt token in the response
            
            return certifikat;
        });
}


function vrniIpKontrolniListNR(sezona,pridelovalecid,kontrolaid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader()
    };
return fetch(`${Vue.prototype.$config.apiUrl}/obrazci/ip/kontrolnilist_v2/${sezona}/${pridelovalecid}/${kontrolaid}`, requestOptions)
        //.then(handleResponse)
        .then(res => {
            let filename="";
          
            const header = res.headers.get('Content-Disposition');
            const parts = header.split(';');
            filename = parts[1].split('=')[1];
            console.log(filename);
            return res.blob().then((blob) => {
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = filename;
                link.click()
                link.remove(); 
                
                //var file = window.URL.createObjectURL(certifikat);
                //window.location.assign(file);
            });

        }) 
        
}

function vrniDatoteko(datotekaid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader()
    };
return fetch(`${Vue.prototype.$config.apiUrl}/datoteka/${datotekaid}`, requestOptions)
        //.then(handleResponse)
        .then(res => {
            let filename="";
          
            const header = res.headers.get('Content-Disposition');
            const parts = header.split(';');
            filename = parts[1].split('=')[1];
            console.log(filename);
            return res.blob().then((blob) => {
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = filename;
                link.click()
                link.remove(); 
                
                //var file = window.URL.createObjectURL(certifikat);
                //window.location.assign(file);
            });

        }) 
        
}

/* dodaj neko verzioniranje */
function vrniIpKontrolniList(sezona,pridelovalecid,kontrolaid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader()
    };
return fetch(`${Vue.prototype.$config.apiUrl}/obrazci/ip/kontrolnilist/${sezona}/${pridelovalecid}/${kontrolaid}`, requestOptions)
        //.then(handleResponse)
        .then(res => {
            let filename="";
          
            const header = res.headers.get('Content-Disposition');
            const parts = header.split(';');
            filename = parts[1].split('=')[1];
            console.log(filename);
            return res.blob().then((blob) => {
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = filename;
                link.click()
                link.remove(); 
                
                //var file = window.URL.createObjectURL(certifikat);
                //window.location.assign(file);
            });

        }) 
        
}

function vrniPoId(id) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader()
    };
return fetch(`${Vue.prototype.$config.apiUrl}/obrazci/${id}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {

            
            return certifikat;
        });
}



function load() {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/obrazci/`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {
            // login successful if there's a jwt token in the response
            
            return certifikat;
        });
}


function save(certifikat) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(certifikat)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/obrazci/`, requestOptions).then(handleResponse);
}


function remove(certifikat) {
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(certifikat)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/certifikat`, requestOptions).then(handleResponse);
}

function loadAll(sezona){
  const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


     return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/certifikati/?sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {
            // login successful if there's a jwt token in the response
            
            return certifikat;
        });
}

function loadLastYear(gerk,status){
    //in tu lahko napišem pravila ali pa jih enostavno potegnem iz baze preko api-ja
    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/certifikat/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {
            // login successful if there's a jwt token in the response
            
            return certifikat;
        });

}
